import { render, staticRenderFns } from "./toAccept.vue?vue&type=template&id=4d563958&scoped=true"
import script from "./toAccept.vue?vue&type=script&lang=js"
export * from "./toAccept.vue?vue&type=script&lang=js"
import style0 from "./toAccept.vue?vue&type=style&index=0&id=4d563958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d563958",
  null
  
)

export default component.exports